import { getParams } from "./browser";
export default function useParams() {
    var params = getParams();
    return {
        user: params.get("username"),
        token: params.get("access_token"),
        disable: params.get("disable") === "true",
    };
}
